import { Image, Modal, message } from "antd";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useToggle } from "react-use";
import ViewParsedText from "../../Components/CommonCommponents/ViewParsedText";
import RequiredFieldProjectModal from "./RequiredFieldProjectModal";

const RequiredFormProjects = (props) => {
  const { projects, candidateId, setEnable } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const [isAddProjectModalOpen, toggleAddProjectModal] = useToggle(false);
  const [currentEditingProject, setCurrentEditingProject] = useState();
  const [editIndex, setEditIndex] = useState(null);
  const DEFAULT_ERROR_MESSAGE =
    "Something went wrong, Please try again after sometime";
  useEffect(() => {
    if (!isAddProjectModalOpen) {
      setCurrentEditingProject({});
      setEditIndex(null);
    }
  }, [isAddProjectModalOpen]);

  return (
    <div>
      <div className="border rounded-md p-spacing3 w-2/3">
        <RequiredFieldProjectModal
          isEditForm={!isEmpty(currentEditingProject)}
          close={toggleAddProjectModal}
          projects={projects}
          details={currentEditingProject}
          editIndex={editIndex}
          setEnable={setEnable}
          candidateId={candidateId}
        />
      </div>
      {/* -----------------------  Modal for Add Experience starts ----------------------- */}
      {isAddProjectModalOpen && (
        <Modal
          className="addExperienceModal"
          width={700}
          open={isAddProjectModalOpen}
          title={"Add Projects"}
          onCancel={toggleAddProjectModal}
          footer={null}
          destroyOnClose
        >
          <RequiredFieldProjectModal
            isEditForm={!isEmpty(currentEditingProject)}
            close={toggleAddProjectModal}
            projects={projects}
            details={currentEditingProject}
            editIndex={editIndex}
            setEnable={setEnable}
            candidateId={candidateId}
          />
        </Modal>
      )}
    </div>
  );
};

export default RequiredFormProjects;
